import Radio from './Radio.jsx';

export default Radio;



// WEBPACK FOOTER //
// ./src/pages/Search/Main/FilterBar/Filter/filters/Radio/index.js